export default "__VITE_ASSET__DtFcqs3X__"